import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const PopupChoiceStep = ({ onClose }) => {
  const navigate = useNavigate();

  // Close with the Escape key
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  const go = (path) => {
    onClose?.();
    navigate(path);
  };

  return (
    <div className="qz-modal-overlay" onClick={onClose}>
      <div
        className="qz-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="qz-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="qz-modal__close" onClick={onClose} aria-label="Close">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true">
            <path d="M6 6l12 12M18 6L6 18" />
          </svg>
        </button>

        <h3 className="qz-modal__title" id="qz-modal-title">Your picks are ready</h3>
        <p className="qz-modal__text">
          Try them on with virtual try-on, or browse the full collection.
        </p>

        <div className="qz-modal__buttons">
          <button type="button" className="qz-btn qz-btn--primary" onClick={() => go("/virtual-try-on")}>
            Try virtual try-on
          </button>
          <button type="button" className="qz-btn qz-btn--outline" onClick={() => go("/all-products")}>
            Browse collection
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupChoiceStep;